import React from "react";
import { DataCloudSource } from "./DataCloudSource";
import { isAwsStorage, isAzureStorage, isGcpStorage, isSfStorage, isUploadStorage, } from "@biggeo/bg-utils";
export const DataCloudSourceWrapper = ({ cloudInfo, fileType, cronInterval, dataSource, square, }) => {
    const storageType = cloudInfo === null || cloudInfo === void 0 ? void 0 : cloudInfo.cloudStorageType;
    return (React.createElement(DataCloudSource, { disableHover: !cloudInfo, fileType: fileType, cronInterval: cronInterval, storageType: storageType, dataSource: dataSource, square: square, aws: cloudInfo && isAwsStorage(cloudInfo)
            ? {
                bucketName: cloudInfo.info.bucketName || undefined,
                storage: cloudInfo.info.storage || undefined,
            }
            : undefined, azure: cloudInfo && isAzureStorage(cloudInfo)
            ? {
                accountName: cloudInfo.info.accountName || undefined,
                containerName: cloudInfo.info.containerName || undefined,
                blobName: cloudInfo.info.blobName || undefined,
            }
            : undefined, sf: cloudInfo && isSfStorage(cloudInfo)
            ? {
                accountId: cloudInfo.info.accountId || undefined,
            }
            : undefined, gcp: cloudInfo && isGcpStorage(cloudInfo)
            ? {
                gcpBucketName: cloudInfo.info.gcpBucketName,
                projectId: cloudInfo.info.projectId || undefined,
            }
            : undefined, upload: cloudInfo && isUploadStorage(cloudInfo)
            ? {
                url: cloudInfo.info.url || undefined,
            }
            : undefined }));
};
//# sourceMappingURL=DataCloudSourceWrapper.js.map